/**
 * https://stackoverflow.com/questions/55012174/why-doesnt-object-keys-return-a-keyof-type-in-typescript
 * https://github.com/microsoft/TypeScript/issues/32321
 */ import jumpToData from "./jumpToData";
export const jumpToPages = Object.keys(jumpToData);
